import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams,HttpClientModule } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment.prod';
import { map } from 'rxjs/operators';
import 'rxjs/add/operator/map';
/*const httpOptions : any    = {
  headers: new HttpHeaders({
    //'Content-Type':  'application/json',
    'Access-Control-Allow-Headers': 'Content-Type, Authorization',
    'Access-Control-Allow-Methods': 'POST',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Origin': '*'
    
  })
};*/
@Injectable({
  providedIn: 'root'
})

export class AuthService {
  imagen_max_size='La imagen no debe exeder mas de 1 mb.';

  

  //url: any = 'http://192.168.1.72:8180';  
  //url: any = 'https://5.183.8.170:3006';  
  url: any = 'https://hoshinup.garocedev.com:3006';  
  url2: any = 'https://hoshinup.garocedev.com:3001';  
  url_5:any='https://hoshinup.garocedev.com:3001';
  urlphp: any = 'https://5.183.8.170/api/index.php/api';  
  //url: any = '';  
/*servicephp(method_,postData){
    let seq = this.http.post<any>(this.urlphp +method_, postData,httpOptions).map((res) => res).toPromise();
    return seq;
  }
  */
  constructor(
    private http: HttpClient
  ) { }
  
  org_head(org){
    var org_=[];  
    for(var i=0;i<org.length;i++){
      if(org[i].director==1)
      org_.push(org[i]);      
    }          
    return org_;
  }
 

  
  
  im_b64(m,postData){   
    let seq = this.http.post<any>('https://hoshinup.garocedev.com:3044'+m, postData).map((res) => res).toPromise();
    return seq;
  }
  ejecuta(qry){
    let postData = {
      qry: qry,
      token: this.token
    }
    return this.http.post(this.url + '/ejecuta', postData);     
  }
  
  token = "$$mex21$$"; 
  ejecuta1(qry){
    let postData = {
      qry: qry,
      token: this.token
    }
    let seq = this.http.post<any>(this.url + '/ejecuta', postData).map((res) => res).toPromise();
    return seq;
  }

  upImagen_ht(data1) {    
  
    let data = {
      DATA: data1 
    }
    let seq = this.http.post<any>(this.url + '/api/upImagen_ht', data).map((res) => res).toPromise();
    return seq;
  }
  upImagencli(data1) {    
    let data = {
      DATA: data1 
    }
    console.log("upImagen_cli");
    console.log(data);
    let seq = this.http.post<any>(this.url + '/api/upImagen_cli', data).map((res) => res).toPromise();
    return seq;
  }
  upImagen(data1) {    
    let data = {
      DATA: data1 
    }
    let seq = this.http.post<any>(this.url + '/api/upImagen', data).map((res) => res).toPromise();
    return seq;
  }

  upImagencelen(data1) {    
    let data = {
      DATA: data1 
    }
    let seq = this.http.post<any>(this.url + '/api/upImagenCelen', data).map((res) => res).toPromise();
    return seq;
  }
  org_=[];
  org=[];
   _org_jerarquizacion(org){
                this.org=org;
                this.org_=[];
                var c=localStorage.getItem("id_role_usu")
                  if(localStorage.getItem("garoce")=="1"){
                    console.log("garoce")
                    for(var i=0;i<this.org.length;i++){
                      if(this.org[i].organo=='D' || this.org[i].organo=='P'){
                        this.org_.push(this.org[i]);                   
                      }
                    }
                  }else{
                    console.log("no-garoce")
                    for(var i=0;i<this.org.length;i++){
                      
                      for(var i=0;i<this.org.length;i++){
                        if(this.org[i].organo=='D' || this.org[i].organo=='P'){
                          this.org_.push(this.org[i]);                   
                        }
                      }
                      
                      /*
                      if(this.org[i].id_role==c){
                        this.org_.push(this.org[i])
                        this.jerarquizacion(c);
                      }*/
                    }
                  }
                  console.log(this.org_);
                  return this.org_;                      
                  
          
  }
  jerarquizacion(id_role_usu){
    for(var i=0;i<this.org.length;i++){
      if(id_role_usu==this.org[i].idarea1){
        if(this.org[i].organo=='D' || this.org[i].organo=='P'  || this.org[i].organo=='A'){         
          this.org_.push(this.org[i]);
        }
      }
    }            
    
  }
  service(method_,postData){
    let seq = this.http.post<any>(this.url +method_, postData).map((res) => res).toPromise();
    return seq;
  }
  
  login(username,password) {
    let postData = {
      username: username,
      password: password
    }
    let seq = this.http.post<any>(this.url + '/login', postData).map((res) => res).toPromise();
    return seq;
  }
  url_fb="";
  fb(postData) {
    this.url_fb="https://graph.facebook.com/v13.0/"+postData.medio+"?"
    if(postData.fields!=undefined){
      this.url_fb=this.url_fb+"fields="+postData.fields+"&"
    }
    this.url_fb=this.url_fb+"access_token="+postData.token;
    let seq = this.http.get<any>(this.url_fb , postData).map((res) => res).toPromise();
    return seq;
  }

  
  municipios(id) {
    let postData = {
      id: id
    }
    let seq = this.http.post<any>(this.url + '/municipios', postData).map((res) => res).toPromise();
    return seq;
  }
  updFirmas(id_sede){   
    let data = {
      "id_sede": id_sede
    }    
    let seq = this.http.post<any>(this.url2 + '/updFirmas', data).map((res) => res).toPromise();
    return seq;
  }
  firmas(id_sede) {
    let postData = {
      "id_sede": id_sede
    }    
    let seq = this.http.post<any>(this.url_5 + '/firmas', postData).map((res) => res).toPromise();    
    return seq;
  }
  

  multihabilidadesTotNN(idencmultihabilidad,idestacion,tpo) {
    let postData = {
      "idencmultihabilidad": idencmultihabilidad,
      "idestacion": idestacion,      
      "tpo": tpo,      
    }

    let seq = this.http.post<any>(this.url + '/multihabilidadesTotNN', postData).map((res) => res).toPromise();
    return seq;
  }

media(data) {      
    let seq = this.http.post<any>(this.url + '/media', data).map((res) => res).toPromise();
    return seq;
  }
desviacion(data) {      
    let seq = this.http.post<any>(this.url + '/desviacion', data).map((res) => res).toPromise();
    return seq;
  }
update_tblmultihabilidadN(edi) {
    let postData = {
      "edi": edi,      
    }
    let seq = this.http.post<any>(this.url + '/update_tblmultihabilidadN', postData).map((res) => res).toPromise();
    return seq;
  }
multihabilidades_N(id,idestacion,pag,per) {
    let postData = {
      "id": id,   
      "idestacion": idestacion,   
      "pag": pag,   
      "per": per,   
    }
    console.log(postData)
    let seq = this.http.post<any>(this.url + '/multihabilidades_N', postData).map((res) => res).toPromise();
    return seq;
  }
xlsx(file) {   
    let postData = {
      file: file,
    }    
    let seq = this.http.post<any>(this.url + '/xlsx', postData).map((res) => res).toPromise();
    return seq;
  }
}
